import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  span {
    height: 3rem;
    float: left;
    width: 3rem;
    margin-right: 1rem;

    strong {
      width: 3rem;
      height: 3rem;
      border-radius: 1.5rem;
      background: ${({ theme, status }) =>
        status
          ? theme.colors.FORM_LABEL_IC_BG_ENABLE
          : theme.colors.FORM_LABEL_IC_BG};
      float: left;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      font-weight: 700;
      margin: 0 1rem 0 0;
    }

    i {
      width: 3rem;
      margin: -3.2rem 0 0 2rem;
      float: left;
      position: relative;
    }
  }

  div {
    float: left;
    display: flex;
    flex-direction: column;

    small {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.FORM_LABEL_TITLE};
    }

    p {
      font-size: 0.8rem;
      color: ${({ theme }) => theme.colors.FORM_LABEL_SUBTITLE};
    }
  }

  @media (max-width: 1024px) {
    span {
      width: 3rem;
      height: 3rem;
      border-radius: 1.5rem;

      i {
        width: 3rem;
        height: 3rem;
        border-radius: 1.5rem;
        margin: -3.4rem 0 0 1.5rem;
      }

      strong {
        width: 3rem;
        height: 3rem;
        border-radius: 1.5rem;
        font-size: 1rem;
        margin: 0 0.5rem 0 0;
      }
    }

    div {
      small {
        font-size: 1rem;
      }
      p {
        font-size: 0.8rem;
      }
    }
  }
`;
